/* tslint:disable */
/* eslint-disable */
/**
 * Service joined APIs
 * This is the global API definition for all service apis.
 *
 * The version of the OpenAPI document: 1.2.10
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { InternalCommonParentTypesFromJSON, InternalCommonParentTypesToJSON, } from './InternalCommonParentTypes';
import { SkinToneFromJSON, SkinToneToJSON, } from './SkinTone';
/**
 * Check if a given object implements the InternalUserReactionsEmojiRequestV3 interface.
 */
export function instanceOfInternalUserReactionsEmojiRequestV3(value) {
    if (!('parentType' in value) || value['parentType'] === undefined)
        return false;
    if (!('parentId' in value) || value['parentId'] === undefined)
        return false;
    if (!('emojiDefinitionId' in value) || value['emojiDefinitionId'] === undefined)
        return false;
    return true;
}
export function InternalUserReactionsEmojiRequestV3FromJSON(json) {
    return InternalUserReactionsEmojiRequestV3FromJSONTyped(json, false);
}
export function InternalUserReactionsEmojiRequestV3FromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'parentType': InternalCommonParentTypesFromJSON(json['parent_type']),
        'parentId': json['parent_id'],
        'emojiDefinitionId': json['emoji_definition_id'],
        'skinTone': json['skin_tone'] == null ? undefined : SkinToneFromJSON(json['skin_tone']),
    };
}
export function InternalUserReactionsEmojiRequestV3ToJSON(json) {
    return InternalUserReactionsEmojiRequestV3ToJSONTyped(json, false);
}
export function InternalUserReactionsEmojiRequestV3ToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'parent_type': InternalCommonParentTypesToJSON(value['parentType']),
        'parent_id': value['parentId'],
        'emoji_definition_id': value['emojiDefinitionId'],
        'skin_tone': SkinToneToJSON(value['skinTone']),
    };
}
